<template>
  <div class="launchpack-delivery">
    <admin-filter
      ref="adminFilter"
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    >
      <!-- 체크박스 -->
      <div slot="status_list">
        <div class="control">
          <lp-check-group :list="[{label: '전체', value:'all'},
        {label: '상품준비중', value: 200},
        {label: '배달대기', value: 300},
        {label: '배달중', value: 301},
        {label: '배달완료', value: 302},
        {label: '취소', value: 'cancel'}]"
                          :data="selected_status_list"
                          @check="selCheckBox"
                          value_name="value"
                          label_name="label"></lp-check-group>
        </div>
      </div>

      <div slot="partner" v-if="$store.getters.mode!=='partner'">
        <lp-adm-drop-input :data.sync="partners"
                           @onSelect="selectPartner"
                           placeholder="검색 후 선택"
                           listAlign="left"
                           width="250px"
                           style="margin-top:12px;"></lp-adm-drop-input>
      </div>s
    </admin-filter>

    <div class="btn-group-justify-end">
      <button class="button" style="width:150px" @click="orderDownloadFile()">
        <img style="width: 10px;margin-right: 4px;"
             src="~assets/image/excel_icon.png"/>
        <span>주문 내역 다운로드</span></button>
    </div>

    <div class="flex">
      <div class="basic-tab" :class="{'tab-selected': selectedTab===0}" @click="selectedTab=0">주문번호별</div>
      <div class="basic-tab" :class="{'tab-selected': selectedTab===1}" @click="selectedTab=1">상품주문번호별</div>
    </div>

    <!-- 탭 1 -->
    <order-table
      ref="orderTable"
      :field_list="tableData"
      :items="tableItems"
      :filtered="filtered"
      :allCount="allCount"
      :filteredCount="filteredCount"
      @check="clickCheckBox"
      :table_width="2000"
      @getData="getDataFromServer"
      :totalPrice="totalPrice"
      @ordering="ordering"
      @selPageLength="selPageLength" v-if="selectedTab===0">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!--   수령 희망일   -->
      <td slot="hope_day" slot-scope="props">
        {{ props.item.hope_day }}
      </td>

      <!--  결제일   -->
      <td slot="pay_day" slot-scope="props">
        <div v-if="props.item.pay_type===900">결제 없음</div>
        <div v-else-if="props.item.pay_type===901">결제 대기</div>
        <div v-else>{{ props.item.pay_day }}</div>
      </td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.id}&page=OrderListPayAll`)" class="unselect"
             style="text-decoration:underline">{{ props.item.order_num }}
        </div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props">{{
        props.item.created_time }}
      </td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props">{{
        props.item.name }}
      </td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <!--   상품 금액   -->
      <td slot="product_price" slot-scope="props">
        {{ props.item.product_price | currency }}
      </td>

      <td slot="product" slot-scope="props">
        <div class="flex align-center" v-if="props.item.order_product">
          <img :src="props.item.order_product.product.img" style="width:35px;height:35px;margin-right:6px"
               v-if="props.item.order_product.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product.order_product_option.length>0">
              <div>{{ props.item.order_product.product.name }}
                <span v-if="props.item.order_product_count>1"> 외 {{ props.item.order_product_count - 1}}개</span>
              </div>
              <div
                v-for="(option, option_idx) in props.item.order_product.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.order_product.product.name }}
              <span v-if="props.item.order_product_count>1"> 외 {{ props.item.order_product_count - 1}}개</span>
            </div>
          </div>
        </div>
      </td>

      <!-- 배달 금액 -->
      <td slot="delivery_cost" slot-scope="props">{{ props.item.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>

      <!-- 전체 금액 -->
      <td slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</td>

      <!-- 포인트 -->
      <td slot="point" slot-scope="props">{{ props.item.point | currency }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type_kor }}</span></td>

      <!-- 배달 정보 -->
      <td slot="delivery_info" slot-scope="props" style="position:relative">
        <div class="delivery-section" style="cursor: pointer">
          <i class="material-icons">library_books</i>
          <div class="delivery-info">
            <div style="display:inline-block;width:30%">수령자</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.name }}</div>
            <div style="display:inline-block;width:30%">휴대전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.tphone }}</div>
            <div style="display:inline-block;width:30%">일반전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.phone }}</div>
            <div style="display:inline-block;width:30%">주소</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.address }}</div>
            <div style="display:inline-block;width:30%">배달메시지</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.memo }}</div>
          </div>
        </div>
      </td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr"
                      :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리
          </button>
        </div>
      </div>
    </order-table>

    <!-- 탭 2 -->
    <order-table
      ref="orderTable"
      :field_list="tableData"
      :items="tableItems"
      :filtered="filtered"
      :allCount="allCount"
      :filteredCount="filteredCount"
      @check="clickCheckBox"
      :table_width="2200"
      @getData="getDataFromServer"
      :totalPrice="totalPrice"
      @ordering="ordering"
      @selPageLength="selPageLength" v-if="selectedTab===1">
      <td slot="checkspot" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!--   수령 희망일   -->
      <td slot="order__hope_day" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{
        props.item.order.hope_day }}
      </td>

      <!--  결제일   -->
      <!--  결제일   -->
      <td slot="order__pay_day" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <div v-if="props.item.order.pay_type===900">결제 없음</div>
        <div v-else-if="props.item.order.pay_type===901">결제 대기</div>
        <div v-else>{{ props.item.order.pay_day }}</div>
      </td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListPayAll`)" class="unselect"
             style="text-decoration:underline">{{ props.item.id }}
        </div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{
        props.item.created_time }}
      </td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{
        props.item.order.name }}
      </td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center unselect"
             @click="routerProduct(props.item.product)">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px"
               v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배달 금액 -->
      <td slot="delivery_cost" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{
        props.item.order.delivery_cost | currency }}
      </td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{
        props.item.order.total_price | currency }}
      </td>

      <!-- 포인트 -->
      <td slot="point" slot-scope="props">{{ props.item.point | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>


      <!-- 주문 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type_kor }}</span></td>

      <!-- 배달 정보 -->
      <td slot="delivery_info" slot-scope="props" style="position:relative">
        <div class="delivery-section" style="cursor: pointer">
          <i class="material-icons">library_books</i>
          <div class="delivery-info">
            <div style="display:inline-block;width:30%">수령자</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.name }}</div>
            <div style="display:inline-block;width:30%">휴대전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.tphone }}</div>
            <div style="display:inline-block;width:30%">일반전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.phone }}</div>
            <div style="display:inline-block;width:30%">주소</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.address }}</div>
            <div style="display:inline-block;width:30%">배달메시지</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.memo }}</div>
          </div>
        </div>
      </td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr"
                      :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리
          </button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <modal-confirm :count="selectedValue.selected.length" @confirm="confirmStatusChange"
                   @closeModal="closeModal"></modal-confirm>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import MartMixin from "@/mixins/MartMixin"
  import ModalConfirm from "../components/ModalConfirm";
  import LpCheckGroup from "../../../module/common/LpCheckGroup";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: 'OrderListPayAll',
    components: {LpAdmDropInput, LpCheckGroup, ModalConfirm, LpCheckBool},
    mixins: [
      MartMixin
    ],
    data() {
      return {
        selected_status_list: ['all',200,300,301,302,'cancel']
      }
    },
    watch: {
      selectedTab(n) {
        if (this.selectedTab === 0) {
          this.initializing('pay_all_tab1', 'mart/order', 'OrderListPayAll');
          // this.initializing('pay_all_tab1', 'mart/orderproduct?start_status=100&end_status=400', 'OrderListPayAll');
        }
        if (this.selectedTab === 1) {
          this.initializing('pay_all_tab2', 'mart/orderproduct', 'OrderListPayAll');
          // this.initializing('pay_all_tab2', 'mart/orderproduct?start_status=100&end_status=400', 'OrderListPayAll');
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // (테이블 필드, 사용할 api, 현재페이지)
        this.selectedTab = 1;
        this.initializing('pay_all_tab2', 'mart/orderproduct', 'OrderListPayAll');
      },
      getDataFromServer() {
        this.getData();
      },
      selCheckBox() {
        let value = this.selected_status_list;
        this.filtered.page_num = 1;
        let status_list = '';
        for(let i=0; i<value.length; i++) {
          // 전체 선택일 경우 예외처리
          if(value[i]==='all') {
            status_list = '';
            break;
          }
          if(i===value.length-1) {
            if(value[i]==='cancel') {
              status_list += '500,501,503,504'
            }
            else status_list += value[i];
          }
          else {
            if(value[i]==='cancel') {
              status_list += '500,501,503,504,'
            }
            else status_list += value[i] + ','
          }
        }
        this.filtered['status_list'] = status_list;
        this.getData();
        // console.log('체크박스 선택', key, value);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb

  .delivery-info
    position absolute
    left -170px
    top 38px
    background #eee
    z-index 10
    padding 8px
    width 240px

  .delivery-info
    display none

  .delivery-section:hover .delivery-info
    display block
</style>
